export default __webpack_public_path__ + "static/media/icon_flag_england.88fdd45f.svg";